export function createDebounce(func: () => unknown, timeout = 250): () => unknown {
    let timer: NodeJS.Timer;
    return () => {
        clearTimeout(timer);

        timer = setTimeout(() => func(), timeout);
    };
}
